import React from 'react';

import { TextForm } from './form';
import { TextSlides } from './slides';
import { useReels } from '../../../../../contexts/reels';

export const Text: React.FC = () => {
  const { textSlides } = useReels();
  return (
    <div className={'reels-text-slide-container'}>
      <TextForm />
      {textSlides.length > 0 && <TextSlides />}
    </div>
  );
};
